import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function Impressum() {
  return (
    <div className="legal-root">
      <div className="legal-bg-grid" />
      <div className="legal-glow" />

      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo.png" alt="CVFlow" className="legal-logo__dot" />
        </Link>
      </header>

      <main className="legal-main">
        <div className="legal-eyebrow">Rechtliche Informationen</div>
        <h1 className="legal-title">Impressum</h1>
        <div className="legal-divider" />

        <div className="legal-card">

          <section className="legal-section">
            <h2 className="legal-section__title">Angaben gemäß § 5 DDG</h2>
            <div className="legal-block">
              <p className="legal-name">Ahmet Furkan Yazgin &amp; Mehmet Yüksel GbR</p>
              <p className="legal-prose">
                Kaltenweide 182<br />
                25335 Elmshorn
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                <strong>Vertreten durch die Gesellschafter:</strong><br />
                Ahmet Furkan Yazgin<br />
                Mehmet Yüksel
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">Kontakt</h2>
            <div className="legal-block legal-block--grid">
              <div className="legal-contact-row">
                <span className="legal-contact-label">Telefon</span>
                <a href="tel:015207166405" className="legal-contact-value">015207166405</a>
              </div>
              <div className="legal-contact-row">
                <span className="legal-contact-label">E-Mail</span>
                <a href="mailto:info@cvflow.de" className="legal-contact-value">info@cvflow.de</a>
              </div>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Ahmet Furkan Yazgin<br />
                Kaltenweide 182<br />
                25335 Elmshorn
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">EU-Streitschlichtung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-inline-link"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="legal-prose" style={{ marginTop: 8 }}>
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>

        </div>

        <div className="legal-footer-nav">
          <Link to="/agb" className="legal-footer-link">AGB →</Link>
          <Link to="/datenschutz" className="legal-footer-link">Datenschutzerklärung →</Link>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="legal-footer__inner">
          <div className="legal-footer__brand">
            <img src="/logo.png" alt="CVFlow" className="legal-footer__brand-dot" />
          </div>
          <nav className="legal-footer__links">
            <Link to="/impressum">Impressum</Link>
            <Link to="/agb">AGB</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
          <div className="legal-footer__status">
            <span className="legal-footer__status-dot" aria-hidden="true" />
            System Online · Made in Germany
          </div>
        </div>
      </footer>
    </div>
  );
}
